import { Formik, FormikHelpers } from 'formik';
import { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetCampaign, useUpdateCampaign } from '../../../../service/hooks';
import { MLS_SOURCE } from '../../../../utils/constants';
import CampaignForm from '../forms/CampaignForm';
import { CAMPAIGN_FORM_VALUES, CAMPAIGN_SCHEMA } from '../forms/schema';

const CampaignDetails: FC = () => {
  const navigate = useNavigate();
  const { mutate: updateCampaign } = useUpdateCampaign();
  const params = useParams();
  const { data: campaign } = useGetCampaign(params?.id as string);

  const onSubmit = (
    values: CAMPAIGN_FORM_VALUES,
    { setSubmitting, resetForm }: FormikHelpers<CAMPAIGN_FORM_VALUES>,
  ) => {
    const {
      listingContractDateFrom,
      listingContractDateTo,
      listingContractDateGreaterThanDays,
      listingContractDateLessThanDays,
      city,
      stateOrProvince,
      listPriceFrom,
      listPriceTo,
      yearBuiltFrom,
      yearBuiltTo,
      radiusInMiles,
      listAgentEmailOmitIfNotExists,
      ...rest
    } = values;

    const payload = {
      campaignSearchQuery: {
        listingContractDateFrom,
        listingContractDateTo,
        listingContractDateGreaterThanDays,
        listingContractDateLessThanDays,
        city,
        stateOrProvince,
        listPriceFrom,
        listPriceTo,
        yearBuiltFrom,
        yearBuiltTo,
        radiusInMiles,
        listAgentEmailOmitIfNotExists,
      },
      ...rest,
    };

    updateCampaign(
      { ...payload, id: params?.id as string },
      {
        onSuccess: () => {
          resetForm();
          navigate('/');
        },
        onSettled: () => {
          setSubmitting(false);
        },
      },
    );
  };

  const { campaignSearchQuery, ...rest } = campaign ?? {};
  const {
    listingContractDateFrom,
    listingContractDateTo,
    listingContractDateGreaterThanDays,
    listingContractDateLessThanDays,
    city,
    stateOrProvince,
    listPriceFrom,
    listPriceTo,
    yearBuiltFrom,
    yearBuiltTo,
    radiusInMiles,
    subdivisionName,
    listOfficeName,
    newConstructionYN,
    ownership,
    seniorCommunityYN,
    standardPropertyTypes,
    standardStatus,
    listAgentEmailOmitIfNotExists,
    mlsSource,
  } = campaignSearchQuery ?? {};

  if (!campaign) {
    return <div />;
  }

  return (
    <div className="mt-16">
      <Formik
        initialValues={
          {
            name: campaign?.name ?? '',
            mlsSource: mlsSource ?? MLS_SOURCE.V1,
            stateOrProvince: stateOrProvince ?? '',
            city: city ?? '',
            radiusInMiles: radiusInMiles ?? 0,
            listingContractDateFrom,
            listingContractDateTo,
            listingContractDateGreaterThanDays,
            listingContractDateLessThanDays,
            listPriceFrom,
            listPriceTo,
            yearBuiltFrom,
            yearBuiltTo,
            subdivisionName,
            listOfficeName,
            newConstructionYN,
            ownership,
            seniorCommunityYN,
            standardPropertyTypes,
            standardStatus,
            listAgentEmailOmitIfNotExists,
            ...rest,
          } as CAMPAIGN_FORM_VALUES
        }
        onSubmit={onSubmit}
        validationSchema={CAMPAIGN_SCHEMA}
      >
        {() => <CampaignForm isEdit={false} />}
      </Formik>
    </div>
  );
};

export default CampaignDetails;
